import { useCallback } from 'react'
import { useRefinementList } from 'react-instantsearch'

import { Accordion } from 'scripts/react-components/site/EntryKey/components'

import { onFilterDataLayer } from 'site/AlgoliaEntryKey/utils/data-layer'
import { useAlgoliaContext } from 'site/AlgoliaEntryKey/context/algolia-context'

import { FilterOptions, FilterTitle } from '../Filters/components'
import { filterToRender, MappedAttributes } from '../../utils/filterToRender'

interface accordionFilterProps {
  attribute: MappedAttributes
  filterIndex: number
}

const AccordionFilter = ({ attribute, filterIndex }: accordionFilterProps) => {
  const { canRefine, items, refine } = useRefinementList({ attribute })
  const { gaTrack, pageType, query } = useAlgoliaContext()

  const getSelectedItems = () => items.filter((item) => item.isRefined)

  const handleRefine = useCallback(
    (value: string, index: number) => {
      const url = new URL(window.location.href)

      onFilterDataLayer({
        gaTrack,
        term: query,
        pageType,
        filter: 'Normal',
        filterType: { index: filterIndex, value: filterToRender(attribute) },
        filterElement: { index, value },
        isParamAlreadySet: url.searchParams.has(attribute)
      })

      refine(value)
    },
    [gaTrack, query, pageType, filterIndex, attribute, refine]
  )

  if (!canRefine) return null

  return (
    <Accordion
      title={
        <FilterTitle
          filter={{
            name: filterToRender(attribute),
            selected: Boolean(getSelectedItems().length),
            options: getSelectedItems()
          }}
        />
      }
    >
      <FilterOptions options={items} refine={handleRefine} />
    </Accordion>
  )
}

export default AccordionFilter
